import { render, staticRenderFns } from "./DocumentIconComponent.vue?vue&type=template&id=4ff32fcb&scoped=true"
import script from "./DocumentIconComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentIconComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DocumentIconComponent.vue?vue&type=style&index=0&id=4ff32fcb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff32fcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff32fcb')) {
      api.createRecord('4ff32fcb', component.options)
    } else {
      api.reload('4ff32fcb', component.options)
    }
    module.hot.accept("./DocumentIconComponent.vue?vue&type=template&id=4ff32fcb&scoped=true", function () {
      api.rerender('4ff32fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/components/uploaderComponent/components/DocumentIconComponent.vue"
export default component.exports